import { render, staticRenderFns } from "./PagesEditExisitng.vue?vue&type=template&id=1513b41a&scoped=true&"
import script from "./PagesEditExisitng.vue?vue&type=script&lang=js&"
export * from "./PagesEditExisitng.vue?vue&type=script&lang=js&"
import style0 from "./PagesEditExisitng.vue?vue&type=style&index=0&id=1513b41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513b41a",
  null
  
)

export default component.exports